export const EDIT_PROFILE_UPDATE_FIELD = "EDIT_PROFILE_UPDATE_FIELD";
export const EDIT_PROFILE_SET_STATE = "EDIT_PROFILE_SET_STATE";

export const TECH_PROFILE_SCROLL_TO_SECTION = "TECH_PROFILE_SCROLL_TO_SECTION";

export const TECH_PROFILE_LINK_CHANGES = "TECH_PROFILE_LINK_CHANGES";

export const TECH_PROFILE_PUBLISH_REQUEST = "TECH_PROFILE_PUBLISH_REQUEST";
export const TECH_PROFILE_PUBLISH_SUCCESS = "TECH_PROFILE_PUBLISH_SUCCESS";
export const TECH_PROFILE_PUBLISH_FAIL = "TECH_PROFILE_PUBLISH_FAIL";
export const TECH_PROFILE_PUBLISH_RESET = "TECH_PROFILE_PUBLISH_RESET";

export const TECH_PROFILE_USERNAME_CHECK_REQUEST =
  "TECH_PROFILE_USERNAME_CHECK_REQUEST";
export const TECH_PROFILE_USERNAME_CHECK_SUCCESS =
  "TECH_PROFILE_USERNAME_CHECK_SUCCESS";
export const TECH_PROFILE_USERNAME_CHECK_FAIL =
  "TECH_PROFILE_USERNAME_CHECK_FAIL";
export const TECH_PROFILE_USERNAME_CHECK_RESET =
  "TECH_PROFILE_USERNAME_CHECK_RESET";

export const TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST =
  "TECH_PROFILE_GET_DATA_BY_USERNAME_REQUEST";
export const TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS =
  "TECH_PROFILE_GET_DATA_BY_USERNAME_SUCCESS";
export const TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL =
  "TECH_PROFILE_GET_DATA_BY_USERNAME_FAIL";

export const TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST =
  "TECH_PROFILE_GET_PREVIOUS_DATA_REQUEST";
export const TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS =
  "TECH_PROFILE_GET_PREVIOUS_DATA_SUCCESS";
export const TECH_PROFILE_GET_PREVIOUS_DATA_FAIL =
  "TECH_PROFILE_GET_PREVIOUS_DATA_FAIL";
export const TECH_PROFILE_GET_PREVIOUS_DATA_RESET =
  "TECH_PROFILE_GET_PREVIOUS_DATA_RESET";
